import React, { useEffect, useState } from 'react'
import { MARKI_Z_LOGO } from '../elektryka/markiZLogo'

/**
 * Logo producenta z `public/*_manufacturers` (te same pliki co na stronach modeli).
 *
 * Tu mamy NAZWĘ producenta z katalogu („LONGi Solar”, „JA Solar”, „RCT POWER”), a nie
 * slug, więc dopasowanie jest dokładne: sklejona nazwa albo nazwa bez końcówki
 * „solar/energy/power/tech”. Dopasowanie po fragmencie dałoby Recom logo REC.
 *
 * Gdy logo nie ma, pokazujemy `zapas` (zwykle samą nazwę). Brak logo nic nie mówi
 * o produkcie, więc nie zostawiamy pustego miejsca.
 */

const KATALOG = {
  falownik: ['inverter', 'inverters_manufacturers'],
  magazyn: ['battery', 'magazines_manufacturers'],
  moduly: ['panels', 'panels_manufacturers'],
  ladowarka: ['wallbox', 'wallboxes_manufacturers'],
}

const sklej = (t) => String(t).toLowerCase().replace(/[^a-z0-9]/g, '')

/** Nazwa pliku logo (bez rozszerzenia) albo null. */
export const plikLogo = (producent, rola) => {
  const k = KATALOG[rola]
  if (!producent || !k) return null
  const s = sklej(producent)
  const warianty = [s, s.replace(/(solar|energy|power|tech)$/, '')]
  return MARKI_Z_LOGO[k[0]].find((m) => warianty.includes(m.replace(/-/g, ''))) || null
}

const LogoMarki = ({ producent, rola, className = 'h-5 max-w-[80px]', zapas = null }) => {
  const [blad, setBlad] = useState(false)
  useEffect(() => { setBlad(false) }, [producent, rola])
  const plik = plikLogo(producent, rola)
  if (!plik || blad) return zapas
  return (
    <img src={`${process.env.PUBLIC_URL}/${KATALOG[rola][1]}/${plik}.jpg`} alt={producent} title={producent}
         onError={() => setBlad(true)} className={`w-auto object-contain mix-blend-multiply dark:mix-blend-normal ${className}`} />
  )
}

export default LogoMarki
